import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { MultiTariffService } from '../multi-tariff.service';
import { MAX_PERIODS, MAX_RATES, Rate, ValidationFlags } from '../multi-tariff.model';

@Component({
	selector: 'app-multi-tariff-rates',
	templateUrl: './rates.component.html',
	styleUrls: ['./rates.component.css']
})
export class RatesComponent implements OnChanges {

	@Input() rates: Rate[] = [];
	@Input() currency: number = null;
	@Input() invalidFields: ValidationFlags = null;
	@Input() readonly = false;

	@Output() ratesChange = new EventEmitter<{ rates: Rate[], deletedRateIndex?: number }>();

	readonly maxRates = MAX_RATES;
	readonly maxPeriods = MAX_PERIODS;

	selectedCurrency = '';

	constructor(public multiTariffService: MultiTariffService) { }

	ngOnChanges() {
		this.selectedCurrency = this.multiTariffService.getCurrencyName(this.currency);
	}

	addRate() {
		const rates = cloneDeep(this.rates);
		rates.push({ name: '', periods: [{ name: '', from: '00:00', to: '00:00', price: null }] });

		this.rates = rates;
		this.emit();
	}

	removeRate(rateIndex: number) {
		const rates = cloneDeep(this.rates);
		rates.splice(rateIndex, 1);

		this.rates = rates;
		this.emit(rateIndex);
	}

	addPeriod(rateIndex: number) {
		const rates = cloneDeep(this.rates);
		rates[rateIndex].periods.push({ name: '', from: '00:00', to: '00:00', price: null });

		this.rates = rates;
		this.emit();
	}

	removePeriod(rateIndex: number, periodIndex: number) {
		const rates = cloneDeep(this.rates);
		rates[rateIndex].periods.splice(periodIndex, 1);

		this.rates = rates;
		this.emit();
	}

	emit(deletedRateIndex?: number) {
		this.ratesChange.emit({ rates: this.rates, deletedRateIndex });
	}
}
